import React from "react"
import {
  FormErrorMessage,
  FormControl,
  FormLabel,
  InputLeftElement,
  InputGroup,
  Input,
} from "@chakra-ui/react"
import { Icon } from "../"

export default function FormName({ register, success, error }) {
  return (
    <FormControl isInvalid={error}>
      <FormLabel htmlFor="name">Name *</FormLabel>
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          children={<Icon name="avatar" color="primary.200" />}
        />
        <Input
          name="name"
          {...(success && { pointerEvents: "none" })}
          {...register("name", {
            required: {
              value: true,
              message: "Please provide a name",
            },
          })}
        />
      </InputGroup>
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </FormControl>
  )
}
